import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";  // GEÇİCİ: teşhis için
import App from "./App";
import ErrorBoundary from "./ErrorBoundary";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <HashRouter>
        <App />
      </HashRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
